import src from "IMAGE";
export default { src, width: 125, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABUaIiwRGSAqBhMYIgcUGCIHExchEA8SHTQRDyEvDg0dABoeIisWGyAqCBgdKQodJjUIFhwnHxcdLkkYFjBJFRMv2EkHJ2HrePwAAAAASUVORK5CYII="};
